'use strict';
define(['app'], function (app) {
    /* Shared tool heading (from Keyword Planner): boxed icon, title, optional
       trailing note and subtitle. Pass a tabler class via `icon`, or project a
       custom <svg> as content when a tool needs its own glyph. */
    app.component('stToolHeading', {
        templateUrl: 'app/components/st-tool-heading/st-tool-heading.html',
        transclude: true,
        bindings: {
            icon: '@',
            title: '@',
            subtitle: '@',
            note: '@'
        }
    });
});
